import axios from '@/axios'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createConfig(context, configData) {
    return new Promise((resolve, reject) => {
      axios
        .post('configs', configData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countConfig(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`configs/count/?${query}`)
        .then(response => {
          context.commit('SET_CONFIGS_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchConfigs(context) {
    const query = QuerySerialize(context.state.query)
    const skip = context.state.skip
    const limit = context.state.limit
    return new Promise((resolve, reject) => {
      axios
        .get(`configs/?skip=${skip}&limit=${limit}&${query}`)
        .then(response => {
          context.commit('SET_CONFIGS', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchConfig(context, configId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`configs/${configId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  async fetchGeneralConfigs(context) {
    const query = QuerySerialize({ groups: 'general' })
    try {
      const response = await axios.get(`configs/?${query}`)
      if (response) {
        context.commit('SET_GENERAL_CONFIGS', response.data)
      }
    } catch (error) {
      notifyServerError(error)
    }
  },
  removeConfig({ commit }, configId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`configs/${configId}`)
        .then(response => {
          commit('REMOVE_RECORD', configId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editConfig(context, configData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`configs/${configData.id}`, configData.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
